export default function AccountPage() {
  return (
    <div className="min-h-screen bg-warm py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center py-12">
          <h1 className="text-3xl font-serif font-bold text-slate mb-4">Account</h1>
          <p className="text-gray-600 mb-8">Account features coming soon</p>
          <p className="text-sm text-gray-500">Sign in, order history, and profile management</p>
        </div>
      </div>
    </div>
  );
}
